import { Component, input } from '@angular/core';
import { GcTextComponent } from '@ip-only/front-end-library';

@Component({
  selector: 'app-label-value',
  imports: [GcTextComponent],
  templateUrl: './label-value.component.html',
  styleUrl: './label-value.component.scss',
})
export class LabelValueComponent {
  labelString = input<string>();
  valueString = input<string>();
}
